<p-card>
  <div class="text-lg font-semibold border-bottom-2 border-cyan-500 mb-4">Router Auswahl</div>
  <div class="grid">
    <div class="col-12">
      <div class="text-lg font-semibold mb-2 text-primary">Router bereits vorhanden?</div>
      Zur Nutzung des Anschlusses benötigen Sie zwingend einen mit der gewählten Geschwindigkeit und Technologie kompatiblen Router.<br />
      Bitte beachten Sie: Für die Konfiguration und Einrichtung, sowie allen sicherheitsrelevanten Aktualisierungen, sind Sie selbst verantwortlich.
    </div>
    <div class="col-12 md:col-6">
      <button type="button" pButton label="Ich habe bereits einen Router" icon="fa-solid fa-check" class="mb-2" [class]="{ 'p-button-outlined': !isSelected(customerCpeOption) }" (click)="addProductOption(customerCpeOption)" [disabled]="isDisabled(customerCpeOption)"></button>
    </div>
    <div class="col-12 md:col-6">
      <button type="button" pButton label="Ich habe keinen eigenen Router" icon="fa-solid fa-xmark" class="mb-2" [class]="{ 'p-button-outlined': isSelected(customerCpeOption) }" (click)="remProductOption(customerCpeOption)"></button>
    </div>
    <div class="col-12" *ngIf="messages.length > 0">
      <p-messages [(value)]="messages" [enableService]="false" [closable]="false"></p-messages>
    </div>
    <div class="col-12 md:col-6" *ngFor="let cpeOption of cpeOptions">
      <ow-product-option [product]="cpeOption" [isSelected]="isSelected(cpeOption)" [isDisabled]="isDisabled(cpeOption)" (add)="addProductOption($event)" (rem)="remProductOption($event)"></ow-product-option>
    </div>
  </div>
  <div class="mt-4" *ngIf="productOptions.length > 0">
    <div class="text-lg font-semibold border-bottom-2 border-cyan-500 mb-4">Sonstige Produktoptionen</div>
    <div class="grid">
      <div class="col-12 md:col-6" *ngFor="let productOption of productOptions">
        <ow-product-option [product]="productOption" [isSelected]="isSelected(productOption)" [isDisabled]="isDisabled(productOption)" (add)="addProductOption($event)" (rem)="remProductOption($event)"></ow-product-option>
      </div>
    </div>
  </div>
  <div class="text-sm text-gray-500 mt-4">
    <i class="fa-solid fa-asterisk vertical-align-top"></i>
    Alle Preise verstehen sich zuzüglich der gesetzlich gültigen Mehrwertsteuer
  </div>
  <div class="grid mt-4">
    <div class="col-6">
       <button type="button" pButton label="zurück" (click)="prevStep()" class="p-button-secondary"></button>
    </div>
    <div class="col-6">
        <button type="button" pButton label="weiter" (click)="nextStep()" class="p-button-primary w-full" [disabled]="!(productsService.cpeProduct$ | async)"></button>
    </div>
  </div>
</p-card>
